(function () {

  function translateReviews() {
    const elements = document.querySelectorAll('.jdgm-prev-badge__text:not([data-translated])');

    // 🔒 Vérification : si aucun élément, on stoppe
    if (!elements.length) return;

    elements.forEach(el => {
      if (/reviews?/i.test(el.innerText)) {
        el.innerText = el.innerText.replace(/reviews?/gi, 'avis');
        el.setAttribute('data-translated', 'true');
      }
    });
  }

  // Au chargement initial
  document.addEventListener('DOMContentLoaded', translateReviews);

  // Observation des mutations DOM (AJAX, load more, etc.)
  const observer = new MutationObserver((mutations) => {
    let shouldRun = false;

    for (const mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        shouldRun = true;
        break;
      }
    }  

    if (shouldRun) {
      translateReviews();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();